import { render } from "./BookingTableMobile.vue?vue&type=template&id=527fa157&scoped=true"
import script from "./BookingTableMobile.vue?vue&type=script&lang=js"
export * from "./BookingTableMobile.vue?vue&type=script&lang=js"

import "./BookingTableMobile.vue?vue&type=style&index=0&id=527fa157&lang=css"
import "./BookingTableMobile.vue?vue&type=style&index=1&id=527fa157&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527fa157"]])

export default __exports__